import React from "react";
import { IArticle } from "./contracts/types";
import Soffer from "./soffer";
import { WEBSERVER } from "../services/globals";

type Props = {
  article: IArticle;
  actions?: React.ReactNode;
};

export default function ProductCard({ article, actions }: Props) {
  function detailurl(slug: string | undefined) {
    return `${WEBSERVER}/items/${slug}`;
  }

  return (
    <div className="product h-100 d-flex flex-column">
      <a href={detailurl(article.slug)} className="d-block">
        <div className="img-container">
          <img src={article.img + '?preset=medium&format=webp'} className="img-fluid" alt={article.hname}></img>
          {article.soffer && <Soffer type="top"></Soffer>}
        </div>
        <h4>{article.hname}{article.name ? ` ${article.name}` : ""}</h4>
        <div className="product-description">
          <small dangerouslySetInnerHTML={{ __html: article.hdescription }}></small>
        </div>
      </a>
      {article.soffer ? (
        <div className="price-box">{article.price}</div>
      ) : (
        <div>{article.price}</div>
      )}

      {actions ? (
        actions
      ) : (
        <div className="d-flex flex-row justify-content-between margin-buy-box mt-auto">
          <div>
            <a className="btn btn-info" href={detailurl(article.slug)}>
              Details
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
